var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1587 0.19458C6.15869 0.19458 1.88869 3.30458 0.158691 7.69458C1.88869 12.0846 6.15869 15.1946 11.1587 15.1946C16.1587 15.1946 20.4287 12.0846 22.1587 7.69458C20.4287 3.30458 16.1587 0.19458 11.1587 0.19458ZM11.1587 12.6946C8.39869 12.6946 6.15869 10.4546 6.15869 7.69458C6.15869 4.93458 8.39869 2.69458 11.1587 2.69458C13.9187 2.69458 16.1587 4.93458 16.1587 7.69458C16.1587 10.4546 13.9187 12.6946 11.1587 12.6946ZM11.1587 4.69458C9.49869 4.69458 8.15869 6.03458 8.15869 7.69458C8.15869 9.35458 9.49869 10.6946 11.1587 10.6946C12.8187 10.6946 14.1587 9.35458 14.1587 7.69458C14.1587 6.03458 12.8187 4.69458 11.1587 4.69458Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/openEye.ef7c2f4e1a2199c22f9e4dd840419a02.svg";
export { ForwardRef as ReactComponent };